<template>
    <div id="year-of-study-manager">
        <v-card ref='yearOfStudyManager'>
            <v-card-title>
                Year of Study Manager
                <v-spacer></v-spacer>
                <year-of-study-add v-if="getAccess()" @refreshData="refreshData" @setNotification="setNotification">
                </year-of-study-add>
            </v-card-title>
            <v-card-text>
                <v-data-table :headers="headers" :items="data" sort-by="year">
                    <template v-if="getAccess()" v-slot:item.actions="{ item }">
                        <year-of-study-edit :item="item" @refreshData="refreshData" @setNotification="setNotification">
                        </year-of-study-edit>
                        <year-of-study-delete :item="item" @refreshData="refreshData"
                            @setNotification="setNotification">
                        </year-of-study-delete>
                    </template>
                    <template v-slot:item.getDefault="{ item }">
                        <v-chip :color="getDefaultColor(item)" small>
                            {{ getDefaultLabel(item) }}
                        </v-chip>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import YearOfStudyAdd from './AddYearOfStudy';
import YearOfStudyDelete from './DeleteYearOfStudy';
import YearOfStudyEdit from './EditYearOfStudy';

export default {
    name: 'year-of-study-manager',
    components: {
        YearOfStudyAdd,
        YearOfStudyDelete,
        YearOfStudyEdit
    },
    props: {
        data: {
            required: true,
            type: Array
        },
        permission: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            headers: [{
                    align: 'start',
                    text: 'Year',
                    value: 'year'
                },
                {
                    text: 'Label',
                    value: 'label'
                },
                {
                    text: 'Created Date',
                    value: 'datecode',
                },
                {
                    text: 'Created By',
                    value: 'createdByUsername',
                },
                {
                    sortable: false,
                    text: 'Default',
                    value: 'getDefault',
                },
                {
                    sortable: false,
                    text: 'Actions',
                    value: 'actions'
                }
            ]
        }
    },
    methods: {
        getAccess() {
            if (this.permission.enabled == "1" && this.permission.access == "write") {
                return true;
            }

            return false;
        },
        getDefaultColor(item) {
            if (item.default && item.default == "1") {
                return '#1dc9b7';
            }

            return '#f64e60';
        },
        getDefaultLabel(item) {
            if (item.default && item.default == "1") {
                return 'Yes';
            }

            return 'No';
        },
        refreshData() {
            this.$emit('refreshData');
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        }
    }
}
</script>